import type { CategoryCardType, HistoryTableType } from '@/types'

export const statistics: CategoryCardType[] = [
  {
    id: 1,
    imgCard: '/assets/info/win.png',
    price: 122217,
    priceColor: '#2CEA65',
    title: 'Wins',
  },
  {
    id: 2,
    imgCard: '/assets/info/lose.png',
    price: 34712,
    priceColor: '#FF4A53',
    title: 'Loses',
  },
  {
    id: 3,
    imgCard: '/assets/info/total.png',
    price: 156929,
    priceColor: '#FFFFFF',
    title: 'Total bets',
  },
  {
    id: 4,
    imgCard: '/assets/info/wagered.png',
    price: 1742214,
    priceColor: '#2CEA65',
    prefix: '$',
    title: 'Wagered',
  },
]

export const histories: HistoryTableType[] = [
  {
    id: 1,
    data: [
      {
        color: '#B9C7D4',
        value: 'Rewarded',
      },
      {
        color: '#B9C7D4',
        value: 'Rollback',
      },
      {
        color: '#B9C7D4',
        value: 'Battle Prizes',
      },
      {
        color: '#B9C7D4',
        value: 'Battles Won',
      },
      {
        color: '#B9C7D4',
        value: 'Last Play',
      },
    ],
  },

  {
    id: 2,
    data: [
      {
        color: '#2CEA65',
        value: 52467,
      },
      {
        color: '#B9C7D4',
        value: 12000,
      },
      {
        color: '#B9C7D4',
        value: 4100,
      },
      {
        color: '#2CEA65',
        value: 13,
      },
      {
        color: '#B9C7D4',
        value: 'Aug 2, 2024',
      },
    ],
  },

  {
    id: 3,
    data: [
      {
        color: '#B9C7D4',
        value: 'Rakeback',
      },
      {
        color: '#B9C7D4',
        value: 'PRLL Rakeback',
      },
      {
        color: '#B9C7D4',
        value: 'Challenges Claimed',
      },
      {
        color: '#B9C7D4',
        value: 'Challenge Rewards',
      },
      {
        color: '#B9C7D4',
        value: 'Joined On',
      },
    ],
  },

  {
    id: 4,
    data: [
      {
        color: '#2CEA65',
        value: 52467,
      },
      {
        color: '#B9C7D4',
        value: 23000,
      },
      {
        color: '#B9C7D4',
        value: 2,
      },
      {
        color: '#B9C7D4',
        value: 5123,
      },
      {
        color: '#B9C7D4',
        value: 'Jun 27, 2024',
      },
    ],
  },
]
